import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCards = () => {
  const [stats, setStats] = useState({
    totalCalls: 2847,
    activeAuctions: 156,
    avgBidPrice: 14.67,
    conversionRate: 24.8,
    totalRevenue: 41789.50,
    pendingPayouts: 3456.75
  });

  const [trends, setTrends] = useState({
    totalCalls: { change: 12.5, direction: 'up' },
    activeAuctions: { change: 8.3, direction: 'up' },
    avgBidPrice: { change: 2.1, direction: 'down' },
    conversionRate: { change: 5.7, direction: 'up' },
    totalRevenue: { change: 18.9, direction: 'up' },
    pendingPayouts: { change: 15.2, direction: 'up' }
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setStats(prev => ({
        ...prev,
        totalCalls: prev?.totalCalls + Math.floor(Math.random() * 3),
        activeAuctions: Math.max(100, prev?.activeAuctions + Math.floor(Math.random() * 5) - 2),
        avgBidPrice: prev?.avgBidPrice + (Math.random() - 0.5) * 0.1,
        totalRevenue: prev?.totalRevenue + Math.random() * 50
      }));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    })?.format(amount);
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US')?.format(number);
  };

  const getTrendIcon = (direction) => {
    return direction === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = (direction) => {
    return direction === 'up' ? 'text-success' : 'text-error';
  };

  const statCards = [
    {
      id: 'totalCalls',
      title: 'Total Calls Today',
      value: formatNumber(stats?.totalCalls),
      icon: 'Phone',
      iconColor: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'activeAuctions',
      title: 'Active Auctions',
      value: formatNumber(stats?.activeAuctions),
      icon: 'Activity',
      iconColor: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'avgBidPrice',
      title: 'Avg Bid Price',
      value: `$${stats?.avgBidPrice?.toFixed(2)}`,
      icon: 'Target',
      iconColor: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      id: 'conversionRate',
      title: 'Conversion Rate',
      value: `${stats?.conversionRate}%`,
      icon: 'TrendingUp',
      iconColor: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      id: 'totalRevenue',
      title: 'Total Revenue',
      value: formatCurrency(stats?.totalRevenue),
      icon: 'DollarSign',
      iconColor: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      id: 'pendingPayouts',
      title: 'Pending Payouts',
      value: formatCurrency(stats?.pendingPayouts),
      icon: 'Clock',
      iconColor: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {statCards?.map((card) => (
        <div
          key={card?.id}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-smooth"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 ${card?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.iconColor} />
            </div>
            <button className="p-1 text-muted-foreground hover:text-foreground transition-smooth">
              <Icon name="MoreHorizontal" size={16} />
            </button>
          </div>

          <div className="space-y-1">
            <h3 className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              {card?.title}
            </h3>
            <div className="text-2xl font-bold text-foreground">
              {card?.value}
            </div>
            
            {trends?.[card?.id] && (
              <div className="flex items-center space-x-1">
                <Icon 
                  name={getTrendIcon(trends?.[card?.id]?.direction)} 
                  size={12} 
                  className={getTrendColor(trends?.[card?.id]?.direction)} 
                />
                <span className={`text-xs font-medium ${getTrendColor(trends?.[card?.id]?.direction)}`}>
                  {trends?.[card?.id]?.change}%
                </span>
                <span className="text-xs text-muted-foreground">vs last week</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsCards;